module.exports = __webpack_public_path__ + "img/1_2-finanziario-attico-0.5cf59506.png";